import React from "react";
import { Box } from "@mui/material";
import TranslationWrapper from "../../../../../components/TranslationWrapper/TranslationWrapper";
import FormSwitchTC from "../../../../../components/Forms/FormSwitchTC";
import { useWatch } from "react-hook-form";

export default function AutoImagesSyncSwitch() {
  const autoSyncImportImages = useWatch({ name: "images_auto_sync" });
  const scheduledTaskId = autoSyncImportImages?.id;

  return (
    <FormSwitchTC
      label={
        <Box component={"span"}>
          <TranslationWrapper tDefault={"Images auto sync"} tKey={"vestigingen.form.pos.label.image-autosync"} />{" "}
          {scheduledTaskId ? <a href={`/manager/scheduledTasks/${scheduledTaskId}/edit`}>Edit me</a> : null}
        </Box>
      }
      name={"images_auto_sync__active"}
    />
  );
}
